
import { form12StatusInfoType } from '@/types/Information/Form12';
import { Component, Prop, Vue } from 'vue-property-decorator';

import StepNumber from "@/components/utils/StepNumber.vue";

@Component({
    components:{
        StepNumber
    }
})
export default class Form12ProcessHeader extends Vue {  
    
    @Prop({required: true})
    stepsCompleted!: form12StatusInfoType;

}
